import { t } from "i18next";

class CostBearerModel {
    constructor({
                    id = "",
                    name = "",
                    showLabel = "",
                    message = "",
                    value = "",
                    deleted = false,
                    includedInAGI = false,
                    relatedOrgs = [],

                } = {}) {
         this.id = id;
         this.name = name;
         this.showLabel = showLabel || name;
        this.message = message;
        this.value = value;
        this.deleted = deleted;
        this.includedInAGI = includedInAGI;
        this.relatedOrgs = relatedOrgs;
    }

    static getAttributes(filter = null, validationSchema = null) {
        const attributes = {
            id :{
                'label': 'ID',
                'sortable': true,
                'sortField': 'id',
                'value': (item) => item.id || "",
            },
            name :{
                'label': 'Namn',
                'sortable': true,
                'sortField': 'name',
                'value': (item) => item.name || "",
            },
            message :{
                'label': 'Message',
                'sortable': true,
                'sortField': 'message',
                'value': (item) => item.message || "",
            },
            value :{
                'label': 'KBAR',
                'sortable': true,
                'sortField': 'value',
                'value': (item) => item.value || "",
            },
            deleted :{
                'label': 'Deleted',
                'sortable': true,
                'sortField': 'deleted',
                'showInFilter': false,
                'value': (item) => item.deleted ? t('costBearer.yes') : t('costBearer.no'),
            },
            includedInAGI :{
                'label': 'Included in AGI',
                'sortable': true,
                'sortField': 'includedInAGI',
                'showInFilter': false,
                'value': (item) => item.includedInAGI ? t('costBearer.yes') : t('costBearer.no'),
            },
            relatedOrgs :{
                'label': t('costBearer.relatedOrgs'),
                'sortable': false,
                'sortField': 'relatedOrgs',
                'showInFilter': true,
                'thClass': 'text-start',
                'value': (item) => item.relatedOrgs.join(", ") || "",
            }
        }

        return attributes;
    }
}

export default CostBearerModel;